import React, { useState, useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

const PalletItem = ({ id, selectedPallet, selectedWeight, selectedDimension, selectedType,
  callBackFunction, callBackFunctionDelete, disabled }) => {

  const [pallet_no, setPallet] = useState(selectedPallet || 1);
  const [weight, setWeight] = useState(selectedWeight || '');
  const [dimensions, setDimension] = useState(selectedDimension || '');
  const [type, setType] = useState(selectedType || 'Pallet');

  useEffect(() => {      
    callBackFunction({ type: type });
    callBackFunction({ pallet_no: pallet_no });
  }, [type, callBackFunction, pallet_no])

  const calcpallet = (value) => {
    setPallet(value);
    callBackFunction({ pallet_no: value });
  }

  const calcweight = (value) => {
    setWeight(value);
    callBackFunction({ weight: value });
  }

  const calcdimension = (value) => {
    setDimension(value);
    callBackFunction({ dimensions: value });
  }

  const calctype = (value) => {
    setType(value);
    callBackFunction({ type: value });
  }


  //returns the order item row displayed in the application
  return (
    <Row className={'mb-2'}>
      <Col xs={1}>
        <FormControl 
            value={pallet_no} 
            type={'number'}
            min={1}
            step={1}
            onChange={event => calcpallet(parseInt(event.target.value))}
            onClick={event => calcpallet(parseInt(event.target.value))}
            />
      </Col>
      <Col xs={3}>
        <FormControl 
            value={weight} 
            type={'text'}
            onChange={event => calcweight(event.target.value)}
            />
      </Col>
      <Col xs={2}>
        <FormControl 
            value={dimensions} 
            type={'text'}
            onChange={event => calcdimension(event.target.value)}
            />
      </Col>
      <Col xs={2}>
        <FormControl 
            value={type}
            as='select'
            onChange={event => calctype(event.target.value)}
            >
          <option value="Pallet">Pallet</option>
          <option value="Box">Box</option>
        </FormControl>
      </Col>
      <Col xs={1}>
        <Button
          className='rounded-circle'
          variant='warning'
          id={id}
          disabled={disabled}
          onClick={event => {
            event.preventDefault();
            callBackFunctionDelete();
          }}>
          ✕
        </Button>
      </Col>
    </Row>
  )
}

export { PalletItem };
